// @flow
import { useContext, useCallback } from 'react';
import { FirebaseContext } from '../context/firebase';

const useFirebase = () => {
	const firebase = useContext(FirebaseContext);
	if (!firebase) {
		throw new Error('No FirebaseContext Provider defined');
	}

	const logEvent = useCallback((eventName: string, params: ?{ [key: string]: string | number }) => {
		firebase.analytics().logEvent(eventName, params);
	}, [firebase]);

	const setUserProperties = useCallback((props: { [key: string]: string | number }) => {
		firebase.analytics().setUserProperties(props);
	}, [firebase]);

  const setUserId = useCallback((key: string) => {
		firebase.analytics().setUserId(key);
	}, [firebase]);

	return [logEvent, setUserProperties, setUserId];
};

export default useFirebase;
